<div class="card__order" *ngIf="!this.selectedOption.checked && this.schedulingHours.length != 0">
    <div class="card__title" [ngClass]="{'active-title': this.step}">
      <div style="font-size: 14px;">Opções de entrega</div>
    </div>
    <div class="card__choice__body" [ngClass]="{'active-body': this.step}">

      <div class="card__choice__option">
        <div class="card__choice__option__title">
          <div style="font-size: 14px;">Padrão</div>
        </div>
        <ng-container *ngIf="selectedOption">
        <checkbox-radius [checkboxData]="{ checked: selectedOption.checked, value: 2 }" (checkboxChange)="onCheckboxChange($event)"></checkbox-radius>
        </ng-container>
      </div>
  
      <div class="card__choice__option" *ngIf="schedulingHours.length > 0">
        <div class="card__choice__option__title">
          <div style="font-size: 14px;">Agendada</div>
        </div>
        <ng-container *ngIf="selectedOption">
        <checkbox-radius [checkboxData]="{ checked: selectedOption.checked, value: 1 }" (checkboxChange)="onCheckboxChange($event)"></checkbox-radius>
        </ng-container>
      </div>

    </div>
</div>

<div class="card__order" *ngIf="this.selectedOption.checked && this.schedulingHours.length != 0">
    <div class="card__title">
      <div style="font-size: 14px;">Opções de entrega</div>
    </div>
    <div class="card__selected__body">
        <ng-container *ngIf="this.selectedOption.value == 2">
            <div class="card__selected__option">
                <div class="card__selected__option__title">
                  <div style="font-size: 14px;">Padrão</div>
                </div>
                <div class="card__selected__option__button" >
                  <button (click)="changeButton()">Alterar</button>
                </div>
            </div>
        </ng-container>
        
        <ng-container *ngIf="this.selectedOption.value == 1">
            <div class="card__selected__option">
                <div class="card__selected__option__title">
                  <div style="font-size: 14px;">Agendada, {{timeSelected.value.start}} - {{timeSelected.value.end}}</div>
                </div>
                <div class="card__selected__option__button" *ngIf="!this.hiddenButton">
                  <button (click)="changeButton()">Alterar</button>
                </div>
            </div>
            <div class="change__hour" (click)="this.openCanva()">
              <span>Trocar horário</span>
            </div>
        </ng-container>
    </div>
</div>

<ng-container *ngIf="timeSelectedVariable">
<div class="box-off-canva" [ngClass]="{'open': this.openModalScheduling}" (click)="closeOffCanvas()"></div>
<div class="offcanvas offcanvas-bottom" tabindex="-1" [ngClass]="{'show': openModalScheduling}" style="height: fit-content; z-index: 120;" [ngStyle]="{'height': offCanvasHeight + 'px', 'z-index': 120}" #offCanva>
  <div class="header-info"tabindex="-1" [ngClass]="{'show': openModalScheduling}"  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div></div>
  </div>
  <div class="offcanvas-body">
    <div class="content-offCanva">
      <div class="content-title-offCanva"> 
        <span class="title-offCanva">Agendamento</span>
        <span class="info-offCanva">Escolha o horário para receber o seu pedido</span>
      </div>
      <div class="hour__container">
        <ng-container *ngFor="let hour of schedulingHours">
          <div class="hour__div" *ngIf="hour.available == true" [ngClass]="{'active': hour == timeSelectedVariable.value}">
            <div class="box-time-clock">
              <i class="fa-regular fa-clock"></i>
              <div class="box-time-hours">
                <span>{{hour.start}}</span>
                <span> - </span>
                <span>{{hour.end}}</span>
              </div>
            </div>

            <checkbox-radius [checkboxData]="{ checked: hour == timeSelectedVariable.value, value: hour }" (checkboxChange)="hourselected($event)"></checkbox-radius>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="button-offCanva">
      <button (click)="this.confirmHour()">Confirmar</button>
      <button (click)="openModalScheduling = false;">Fechar</button>
    </div>
  </div>
</div>
</ng-container>

